import type { FaireThemeEntity } from "../../entity_types/theme";

export const baby_blanket_milestone_gifts: FaireThemeEntity = {
  token: "baby-blanket-milestone-gifts",
  type: "theme",
  name: "Baby Blanket & Milestone Gifts",
  description: "",
  teaser: "",
  detail: "",
  bgColor: "#F0D4C4",
  exactProducts: true,
  retailerToken: "r_eer7xgiweo",
  productTokens: [
    "p_ezyqfw5yt2",
    "p_upvvxf5eww",
    "p_muqqd58zxe",
    "p_csbb4tw3uh",
    "p_hyc3pw7ypx",
    "p_ghhxv58z7h",
    "p_r46v6ug9p8",
    "p_32zrh9c8mx",
    "p_jubjgj7vt3",
    "p_7xy9dgwz2j",
    "p_wrzt25uww9",
    "p_y3m5n8as6y",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
